//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from "vuex";
import { date } from "quasar";
import { parse } from "vue-currency-input";
// import { getValue } from "vue-currency-input";
export default {
  props: {
    order: {},
    currencyCode: {},
  },

  data() {
    return {
      showReceiving: false,
      dense: true,
      transactions: [],
      selectedLine: {},
      Locations: [],
      Warehouses: [],
      Products: [],
      FilterWarehouses: [],
      FilterLocations: [],
      FilterProducts: [],
      VatTypes: [],
      currency: "",
      FilterVatTypes: [],
      dimension1: {},
      dimension2: {},
      dimension3: {},
      dimension4: {},
      dimension5: {},
      dimension6: {},
      dimension7: {},
      dimension8: {},
      dimension9: {},
      warehouseId: -1,
      locationId: {},
      recieveQuantity: 0,
      pagination: {
        rowsPerPage: 30, // current rows per page being displayed
      },

      visibleColumns: [
        "productId",
        "itemText",
        "quantity",
        "productUnit",
        "received",
        "remaining",
        "price",
        "discountPercentage",
        "sum",
        "deliveryDate",
        "vatTypeId",
      ],
      columns: [
        {
          name: "productId",
          align: "left",
          label: "Produkt",
          field: "productId",
          sortable: true,
        },
        {
          name: "itemText",
          align: "left",
          label: "Beskrivelse",
          field: "itemText",
          sortable: true,
          headerStyle: "min-width: 300px",
          style: "min-width: 300px",
        },
        {
          name: "quantity",
          align: "right",
          label: "Antall",
          field: "numberOfItems",

          sortable: true,
        },
        {
          name: "productUnit",
          align: "left",
          label: "Enhet",
          field: "productUnit",
          sortable: true,
        },
        {
          name: "received",
          align: "right",
          label: "Motatt",
          field: "received",
          sortable: true,
        },
        {
          name: "remaining",
          align: "right",
          label: "Rest",
          field: "remaining",
          sortable: true,
        },

        {
          name: "price",
          align: "right",
          label: "Pris",
          field: "price",
          sortable: true,
        },

        {
          name: "discountPercentage",
          align: "right",
          label: "Rabatt %",
          field: "discountPercentage",
          sortable: true,
        },
        {
          name: "sum",
          align: "right",
          label: "Sum",
          field: "sum",
          sortable: true,
        },

        {
          name: "deliveryDate",
          align: "right",
          label: "Lev.dato",
          field: "deliveryDate",
          format: (val) => date.formatDate(val, "DD-MM-YYYY"),
          sortable: true,
        },
        {
          name: "vatTypeId",
          align: "left",
          label: "MVA.kode",
          field: "vatTypeId",
          sortable: true,
        },
      ],
      receivedProducts: [
        {
          name: "id",
          align: "left",
          label: "Id",
          field: "id",
          sortable: true,
        },

        {
          name: "locationName",
          align: "left",
          label: "Lokasjonsnavn",
          field: "locationName",
          sortable: true,
        },
        {
          name: "numberOfItems",
          align: "left",
          label: "Motatt",
          field: "numberOfItems",
          sortable: true,
        },
      ],
    };
  },

  computed: {
    ...mapState("main", [
      "warehouses",
      "locations",
      "currencies",
      "suppliers",
      "vatTypes",
      "dimensions",
      "currencies",
    ]),
    currencyOptions() {
      return {
        currency: null,
        locale: "no-NO",
      };
    },
    isRecevingMode() {
      return this.$route.name === "PurchaseReceive";
    },
  },

  methods: {
    ...mapActions("main", [
      "postPurchaseOrderItemTransaction",
      "getArticles",
      "getProject",
      "deletePurchaseOrderItemTransaction",
    ]),
    addRowImproved() {
      const row = {
        productId: null,
        productNumber: null,
        numberOfItems: 1,
        dimension1Id: this.order.dimension1Id,
        dimension2Id: this.order.dimension2Id,
        dimension3Id: this.order.dimension3Id,
        dimension4Id: this.order.dimension4Id,
        dimension5Id: this.order.dimension5Id,
        dimension6Id: this.order.dimension6Id,
        dimension7Id: this.order.dimension7Id,
        dimension8Id: this.order.dimension8Id,
        dimension9Id: this.order.dimension9Id,
      };
      console.log(row);
      this.order.orderItems.push(row);
      this.$emit("rowAdded");
    },

    calculateRow(row) {
      console.log("start oppdatering av rad");

      if (row) {
        if (row.productId) {
          var price = 0;
          console.log(row.price);
          price = parse(row.price, this.currencyOptions);
          const qtySum = row.numberOfItems * price;
          // const vat = this.VatTypes.find((k) => k.id === row.vatTypeId);
          const dicsount = (qtySum * row.discountPercentage) / 100;
          const total = qtySum - dicsount;
          row.sum = new Intl.NumberFormat("no-NO").format(total);
        }
        this.$emit("rowModified");
      }
    },

    getProductsFilter(val, update) {
      if (!this.Products) {
        update();
        return;
      }

      update(
        () => {
          this.Products = this.FilterProducts.filter(
            (p) =>
              p.productName.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
              p.productNumber.toLowerCase().indexOf(val.toLowerCase()) > -1
          );
        },
        (ref) => {
          ref.setOptionIndex(-1);
          ref.moveOptionSelection(1, true);
        }
      );
    },

    addDimensionColumns() {
      this.dimensions.sort((a, b) => {
        return a.dimension.localeCompare(b.dimension);
      });
      this.dimensions.forEach((d) => {
        var d2 = JSON.parse(JSON.stringify(d));
        d2.dimensions.splice(0, 0, { number: null, id: null, name: "" });
        if (d.dimension === "1") this.dimension1 = d2;
        if (d.dimension === "2") this.dimension2 = d2;
        if (d.dimension === "3") this.dimension3 = d2;
        if (d.dimension === "4") this.dimension4 = d2;
        if (d.dimension === "5") this.dimension5 = d2;
        if (d.dimension === "6") this.dimension6 = d2;
        if (d.dimension === "7") this.dimension7 = d2;
        if (d.dimension === "8") this.dimension8 = d2;
        if (d.dimension === "9") this.dimension9 = d2;

        var dimensionId = "dimension" + d.dimension + "Id";
        console.log("has dimension: " + dimensionId + " - " + d.label);
        this.columns.push({
          name: dimensionId,
          align: "left",
          label: d.label,
          field: dimensionId,
          sortable: true,
        });
      });
    },

    getVatTypesFilter(val, update) {
      console.log("getVatTypesFilter", this.VatTypes);
      if (!this.VatTypes) {
        update();
        return;
      }

      update(
        () => {
          this.VatTypes = this.FilterVatTypes.filter(
            (v) =>
              (v.name.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
                v.vatCode.toLowerCase().indexOf(val.toLowerCase()) > -1) &&
              v.visible &&
              !v.deleted &&
              (v.vatCodeGroupID == 11 || v.vatCodeGroupID == 13)
          );

          console.log("getVatTypesFilter update", this.VatTypes);
        },
        (ref) => {
          ref.setOptionIndex(-1);
          ref.moveOptionSelection(1, true);
        }
      );
    },
    async initSelectBox() {
      this.VatTypes = this.vatTypes;
      if (!this.VatTypes) {
        this.VatTypes = await this.getVatType();
      }
      this.FilterVatTypes = this.VatTypes;
    },

    productValueChanged(row, product) {
      console.log("starter endring av produkt");
      console.log(row);
      console.log(product);
      row.productId = product.id;
      row.dirty = 1;
      row.productNumber = product.productNumber;
      row.itemText = product.productName;
      row.productUnit = product.unit;
      row.price = product.supplierProduct.price.toString();
      row.vatTypeId = product.supplierProduct.incomingVatTypeId;
      row.discountPercentage = 0;
      // this.calculateSum();
      this.calculateRow(row);
    },

    vatValueChanged(row, vat) {
      console.log(row);
      console.log(vat);
      row.vatTypeId = vat.id;
    },

    dimension1ValueChanged(row, dimension) {
      row.dimension1Id = dimension.id;
    },
    dimension2ValueChanged(row, dimension) {
      row.dimension2Id = dimension.id;
    },
    dimension3ValueChanged(row, dimension) {
      row.dimension3Id = dimension.id;
    },
    dimension4ValueChanged(row, dimension) {
      row.dimension4Id = dimension.id;
    },
    dimension5ValueChanged(row, dimension) {
      row.dimension5Id = dimension.id;
    },
    dimension6ValueChanged(row, dimension) {
      row.dimension6Id = dimension.id;
    },
    dimension7ValueChanged(row, dimension) {
      row.dimension7Id = dimension.id;
    },
    dimension8ValueChanged(row, dimension) {
      row.dimension8Id = dimension.id;
    },
    dimension9ValueChanged(row, dimension) {
      row.dimension9Id = dimension.id;
    },

    getLocationsFilter(val, update) {
      console.log("getLocationsFilter", this.Locations);
      if (!this.Locations) {
        update();
        return;
      }
      update(() => {
        this.Locations = this.locations.filter(
          (l) => this.warehouseId < 1 || l.warehouseId == this.warehouseId
        );

        console.log("getLocationsFilter update", this.Locations);
      });
    },

    async getProducts() {
      this.Products = await this.getArticles();
      this.FilterProducts = this.Products;
    },

    // async getProjects() {
    //   this.Projects = await this.getProjects();
    //   this.FilterProjects = this.Projects;
    // },

    getWarehouseFilter(val, update) {
      console.log("getWarehouseFilter", this.Warehouses);
      if (!this.Warehouses) {
        update();
        return;
      }
      update(() => {
        this.Warehouses = this.FilterWarehouses.filter(
          (w) =>
            !w.isDeleted &&
            w.warehouseName.toLowerCase().indexOf(val.toLowerCase()) > -1
        );

        console.log("getWarehouseFilter update", this.Warehouses);
      });
    },

    async saveRecieving() {
      console.log(this.recieveQuantity);
      console.log(this.selectedLine.id);
      console.log(this.locationId);

      var postTransaction = {};
      postTransaction.purchaseOrderItemId = this.selectedLine.id;
      postTransaction.locationId = this.locationId;
      postTransaction.numberOfItems = parseFloat(this.recieveQuantity);
      console.log(
        "lagre " +
          postTransaction.purchaseOrderItemId +
          postTransaction.locationId +
          postTransaction.numberOfItems
      );
      try {
        var createdDto = await this.postPurchaseOrderItemTransaction(
          postTransaction
        );
        if (createdDto) {
          this.resetForm();
          await this.$parent.refresh();

          this.$q.notify({
            type: "positive",
            message: this.$t("common.saveOk"),
          });
        } else {
          this.$q.notify({
            type: "negative",
            message: this.$t("common.errorSave"),
          });
        }
      } catch (err) {
        console.log(err.message);
        this.$q.notify({
          type: "negative",
          message: this.$t("common.errorSave"),
        });
      }
    },

    resetForm() {
      this.warehouseId = -1;
      this.locationId = -1;
      this.recieveQuantity = 0;
      this.showReceiving = false;
    },

    async deleteval(row) {
      console.log(row.id);
      var res = await this.deletePurchaseOrderItemTransaction(row.id);
      console.log(res);
      if (res == "true") {
        var index = this.transactions.indexOf(row);
        this.transactions.splice(index, 1);
      } else {
        this.$q.notify({
          type: "negative",
          message: this.$t("common.errorSave"),
        });
      }
    },

    deleteLine(index) {
      this.order.orderItems.splice(index, 1);
    },

    onRowClick(row) {
      this.resetForm();
      this.selectedLine = row;
      this.transactions = row.transactions;

      this.showReceiving = true;
    },
  },
  created() {
    console.log("startet opprett");

    this.Locations = this.locations;
    this.FilterLocations = this.locations;
    this.FilterWarehouses = this.warehouses;
    this.Warehouses = this.warehouses;

    this.getProducts();
    this.initSelectBox();
    this.addDimensionColumns();
  },
  beforeUpdate() {},
};
